export const tutorialGlobalToggles = {
  // Enable/disable instruction ambient loop globally (all missions)
  instructionsAmbientAudio: false,
};

export const tutorialToggles = {
  mission0: {
    // Enable/disable audio in mission instruction pages
    instructionsAudio: true,
    // Tutorial: DECELERATION
    decel: true,
    // Tutorial: ACCELERATION
    accel: true,
    // Tutorial: CAR REVEAL
    reveal: true,
    // Tutorial: FULL LANE SELECTION
    fullLane: true,
    // Tutorial: BOMB HANDLING
    fullLaneTwo: true,
    // Maximum number of allowed failures in the tutorial
    failsCountLimit: 2,
  },
  mission1: {
    // Enable/disable audio in mission instruction pages
    instructionsAudio: true,
    // Ask user if they want to review/practice Mission 0 tutorials
    askRepractice: true,
    // Tutorial: DECELERATION 
    decel: true,
    // Tutorial: ACCELERATION
    accel: true,
    // Tutorial: CAR REVEAL 
    reveal: true,
    // Tutorial: FULL LANE SELECTION
    fullLane: true,
    // Maximum number of allowed failures in the tutorial
    failsCountLimit: 2,
  },
  mission2: {
    // Enable/disable audio in mission instruction pages
    instructionsAudio: true,
    // Tutorial: TRUCK TRUSTING
    truckTrust: true,
    // Tutorial: FULL LANE SELECTION
    fullLane: true,
    // Maximum number of allowed failures in the tutorial
    failsCountLimit: 2,
  },
  mission3: {
    // Enable/disable audio in mission instruction pages
    instructionsAudio: true,
    // Ask user if they want to review/practice basic controls
    askRepractice: true,
    // Tutorial: DECELERATION 
    decel: true,
    // Tutorial: ACCELERATION
    accel: true,
    // Tutorial: CAR REVEAL 
    reveal: true,
    // Maximum number of allowed failures in the tutorial
    failsCountLimit: 2,
  },
  mission5: {
    // Enable/disable audio in mission instruction pages
    instructionsAudio: true,
    // Tutorial: SOLO CHASE FLOW
    soloFlow: true,
    // Tutorial: PARTNER PROPOSAL + SELF LANE FLOW
    cooperationFlow: true,
    // Maximum number of allowed failures in the tutorial
    failsCountLimit: 4,
  }
};
